import React, { useState } from 'react';
import { db } from '../firebase'; 
// Note: We REMOVED the 'storage' import because we aren't using Firebase Storage anymore
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import './Admin.css';

const Admin = () => {
  // --- CONFIGURATION ---
  const CLOUD_NAME = "dbwhboqfx"; // e.g. "dxyz..."
  const UPLOAD_PRESET = "korabou25"; // e.g. "birthday_app"
  
  // --- STATES ---
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [secretCode, setSecretCode] = useState('');
  
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [image, setImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (secretCode === 'love2025') { 
      setIsAuthenticated(true);
    } else {
      alert('Wrong Code');
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!image || !title || !date) {
      alert("Please fill in required fields");
      return;
    }

    setIsUploading(true);

    try {
      // 1. Prepare the file for Cloudinary
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", UPLOAD_PRESET);

      // 2. Send to Cloudinary API
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (!data.secure_url) {
        throw new Error("Cloudinary upload failed");
      }

      // 3. Save the Cloudinary URL to Firestore
      await addDoc(collection(db, "memories"), {
        title,
        description,
        date: Timestamp.fromDate(new Date(date)),
        imageUrl: data.secure_url, // This is the Cloudinary URL
        createdAt: Timestamp.now()
      });

      alert("Success! Memory added.");
      
      // Reset Form
      setTitle("");
      setDescription("");
      setDate("");
      setImage(null);
      setIsUploading(false);

    } catch (error) {
      console.error(error);
      alert("Upload failed: " + error.message);
      setIsUploading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-wrapper">
        <form className="login-box" onSubmit={handleLogin}>
          <h2>Admin Access</h2>
          <input type="password" placeholder="Code" onChange={e => setSecretCode(e.target.value)} />
          <button>Unlock</button>
        </form>
      </div>
    );
  }

  return (
    <div className="admin-wrapper">
      <div className="upload-box">
        <h2>Add Memory (via Cloudinary)</h2>
        <form onSubmit={handleUpload}>
          <input type="text" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} required />
          <input type="date" value={date} onChange={e => setDate(e.target.value)} required />
          <textarea placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} />
          <input type="file" onChange={e => setImage(e.target.files[0])} required />
          
          <button disabled={isUploading}>{isUploading ? 'Uploading...' : 'Save Memory'}</button>
        </form>
      </div>
    </div>
  );
};

export default Admin;